var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "89,18.08 89,73.03 36,73.03 14.88,73.03 14.88,46.13 14.88,18.08 ",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(209,161,132)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "  matrix(1 0 0 1 0 0) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 33.589 76.99 H 6.583 c -1.332 0 -2.411 -1.08 -2.411 -2.411 v -2.893 c 0 -1.332 1.08 -2.411 2.411 -2.411 h 27.005 c 1.332 0 2.411 1.08 2.411 2.411 v 2.893 C 36 75.91 34.92 76.99 33.589 76.99 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(255,236,128)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 30.417 69.274 H 3.411 C 2.08 69.274 1 68.195 1 66.863 v -2.893 c 0 -1.332 1.08 -2.411 2.411 -2.411 h 27.005 c 1.332 0 2.411 1.08 2.411 2.411 v 2.893 C 32.828 68.195 31.748 69.274 30.417 69.274 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(255,236,128)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 33.589 61.558 H 6.583 c -1.332 0 -2.411 -1.08 -2.411 -2.411 v -2.893 c 0 -1.332 1.08 -2.411 2.411 -2.411 h 27.005 c 1.332 0 2.411 1.08 2.411 2.411 v 2.893 C 36 60.479 34.92 61.558 33.589 61.558 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(255,236,128)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 30.417 53.842 H 3.411 C 2.08 53.842 1 52.763 1 51.431 v -2.893 c 0 -1.332 1.08 -2.411 2.411 -2.411 h 27.005 c 1.332 0 2.411 1.08 2.411 2.411 v 2.893 C 32.828 52.763 31.748 53.842 30.417 53.842 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(255,236,128)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 89 13.01 H 19.955 c -2.801 0 -5.072 2.271 -5.072 5.072 v 0 c 0 2.801 2.271 5.072 5.072 5.072 H 89 V 13.01 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(172,130,105)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 14.883 47.127 c -0.552 0 -1 -0.447 -1 -1 V 18.082 c 0 -0.552 0.448 -1 1 -1 s 1 0.448 1 1 v 28.045 C 15.883 46.68 15.436 47.127 14.883 47.127 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 89 74.035 H 36 c -0.552 0 -1 -0.447 -1 -1 s 0.448 -1 1 -1 h 52 V 23.154 c 0 -0.552 0.447 -1 1 -1 s 1 0.448 1 1 v 49.881 C 90 73.588 89.553 74.035 89 74.035 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 89 49.75 H 72.297 c -0.991 0 -1.794 -0.803 -1.794 -1.794 v -6.008 c 0 -0.991 0.803 -1.794 1.794 -1.794 H 89 V 49.75 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(172,130,105)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 89 50.75 H 72.297 c -1.541 0 -2.794 -1.254 -2.794 -2.795 v -6.007 c 0 -1.541 1.253 -2.794 2.794 -2.794 H 89 c 0.553 0 1 0.448 1 1 v 9.597 C 90 50.303 89.553 50.75 89 50.75 z M 72.297 41.153 c -0.438 0 -0.794 0.356 -0.794 0.794 v 6.007 c 0 0.438 0.356 0.795 0.794 0.795 H 88 v -7.597 H 72.297 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 89 24.154 H 19.955 c -3.348 0 -6.072 -2.724 -6.072 -6.072 s 2.724 -6.072 6.072 -6.072 H 89 c 0.553 0 1 0.448 1 1 v 10.144 C 90 23.706 89.553 24.154 89 24.154 z M 19.955 14.01 c -2.245 0 -4.072 1.827 -4.072 4.072 s 1.827 4.072 4.072 4.072 H 88 V 14.01 H 19.955 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 89 19.082 H 25.292 c -0.552 0 -1 -0.448 -1 -1 s 0.448 -1 1 -1 H 89 c 0.553 0 1 0.448 1 1 S 89.553 19.082 89 19.082 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 80.792 45.952 h -5.216 c -0.553 0 -1 -0.448 -1 -1 s 0.447 -1 1 -1 h 5.216 c 0.553 0 1 0.448 1 1 S 81.345 45.952 80.792 45.952 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 33.588 77.99 H 6.583 c -1.881 0 -3.411 -1.53 -3.411 -3.411 v -2.894 c 0 -1.881 1.53 -3.411 3.411 -3.411 h 27.005 c 1.881 0 3.411 1.53 3.411 3.411 v 2.894 C 37 76.46 35.469 77.99 33.588 77.99 z M 6.583 70.274 c -0.778 0 -1.411 0.633 -1.411 1.411 v 2.894 c 0 0.778 0.633 1.411 1.411 1.411 h 27.005 c 0.778 0 1.411 -0.633 1.411 -1.411 v -2.894 c 0 -0.778 -0.633 -1.411 -1.411 -1.411 H 6.583 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 30.417 70.274 H 3.411 C 1.53 70.274 0 68.744 0 66.863 V 63.97 c 0 -1.881 1.53 -3.411 3.411 -3.411 h 27.005 c 1.881 0 3.412 1.53 3.412 3.411 v 2.894 C 33.828 68.744 32.298 70.274 30.417 70.274 z M 3.411 62.559 C 2.633 62.559 2 63.191 2 63.97 v 2.894 c 0 0.778 0.633 1.411 1.411 1.411 h 27.005 c 0.778 0 1.412 -0.633 1.412 -1.411 V 63.97 c 0 -0.778 -0.633 -1.411 -1.412 -1.411 H 3.411 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 33.588 62.559 H 6.583 c -1.881 0 -3.411 -1.53 -3.411 -3.411 v -2.894 c 0 -1.881 1.53 -3.411 3.411 -3.411 h 27.005 c 1.881 0 3.411 1.53 3.411 3.411 v 2.894 C 37 61.028 35.469 62.559 33.588 62.559 z M 6.583 54.843 c -0.778 0 -1.411 0.633 -1.411 1.411 v 2.894 c 0 0.778 0.633 1.411 1.411 1.411 h 27.005 c 0.778 0 1.411 -0.633 1.411 -1.411 v -2.894 c 0 -0.778 -0.633 -1.411 -1.411 -1.411 H 6.583 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 30.417 54.843 H 3.411 C 1.53 54.843 0 53.313 0 51.432 v -2.894 c 0 -1.881 1.53 -3.411 3.411 -3.411 h 27.005 c 1.881 0 3.412 1.53 3.412 3.411 v 2.894 C 33.828 53.313 32.298 54.843 30.417 54.843 z M 3.411 47.127 C 2.633 47.127 2 47.76 2 48.538 v 2.894 c 0 0.778 0.633 1.411 1.411 1.411 h 27.005 c 0.778 0 1.412 -0.633 1.412 -1.411 v -2.894 c 0 -0.778 -0.633 -1.411 -1.412 -1.411 H 3.411 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.3a9763a21c7f96ae0b99f600c2470334.svg";
export { ForwardRef as ReactComponent };